// One line of the coach log (Figma "Panel · Coach actions", 51:4492): what
// the coach did (Changed, Proposed, Wrote, Noticed…), in a few words, with
// where it stands on the right. A tap opens the full card underneath, with
// everything it offers (Undo, Accept, Why?…), so nothing is lost by the
// compact view.
import React, { useState } from 'react';
import { cn } from '../../lib/utils';
import { FOCUS } from '../ds';

const KIND = {
  change: 'Changed',
  proposal: 'Proposed',
  plan_update: 'Wrote',
  observation: 'Noticed',
  safety: 'Looked after you',
  question: 'Asked',
  working: 'Worked on',
  coach_message: 'Said',
  system_action: 'Did',
  athlete_action: 'You did',
  athlete_message: 'You said',
};

const STATE = { accepted: 'Accepted', undone: 'Undone', superseded: 'Replaced', dismissed: 'Dismissed' };

/** `children`: the item's full card, shown when the row is opened. */
export default function CoachActionRow({ item, children }) {
  const [open, setOpen] = useState(false);
  const b = item.body || {};
  const title = b.title || b.text || b.label || '';
  const waiting = item.type === 'proposal' && item.state === 'active';
  const status = waiting ? 'Waiting' : STATE[item.state] || null;
  return (
    <div className="space-y-2">
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open}
        className={cn('flex w-full items-center gap-2.5 rounded-chip border border-border-subtle bg-bg-surface px-3 py-2.5 text-left transition-colors hover:border-border-default', FOCUS)}>
        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
          <span className="type-caption text-text-tertiary">{KIND[item.type] || 'Coach'}</span>
          <span className="truncate type-body-small text-text-primary">{title}</span>
        </span>
        {status && <span className={cn('shrink-0 type-caption', waiting ? 'text-accent-default' : 'text-text-tertiary')}>{status}</span>}
      </button>
      {open && children}
    </div>
  );
}
